import React, { useMemo } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  TextField,
  InputAdornment,
  SvgIcon,
} from '@material-ui/core';
import { Search } from '@material-ui/icons';
import PropTypes from 'prop-types';
import { debounce } from 'lodash';

const CustomerListToolbar = ({ onAdd, onSearch, search, ...rest }) => {
  const onChangeSearch = useMemo(
    () =>
      debounce((event) => {
        onSearch(event?.target?.value);
      }, 500),
    [onSearch],
  );

  return (
    <Box {...rest}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
        }}
      >
        <Button color="primary" variant="contained" onClick={onAdd}>
          Add customer
        </Button>
      </Box>
      <Box sx={{ mt: 2 }}>
        <Card>
          <CardContent>
            <Box>
              <TextField
                defaultValue={search}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SvgIcon fontSize="small" color="action">
                        <Search />
                      </SvgIcon>
                    </InputAdornment>
                  ),
                }}
                placeholder="Search customer"
                variant="outlined"
                type="search"
                onChange={onChangeSearch}
              />
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};

CustomerListToolbar.propTypes = {
  onAdd: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  search: PropTypes.string,
};

export default CustomerListToolbar;
